import {
  Button,
  ProgressBar,
  Row,
  Select,
  Space,
} from "@masterteam/mt-design-react";
import moment from "moment";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import KPIStatusIndicator from "../../KPIStatusIndicator";
import Modal from "../../Modal";
import Table from "../../NewTable";

import useIsAr from "../../../Hooks/useIsAr";
import { measuresMonths } from "../../../helpers";

import { ReactComponent as CloseIcon } from "../../../assets/images/close.svg";
import { ReactComponent as TitleIcon } from "../../../assets/images/objectives-icon.svg";
import { ReactComponent as SortDownIcon } from "../../../assets/images/sort-icon-down.svg";
import { ReactComponent as SortUpIcon } from "../../../assets/images/sort-icon-up.svg";

import { useParams } from "react-router";
import "./style.scss";

function DetailsModal({
  data,
  onClose,
  title,
  statuses,
  isOpen,
  isProject = false,
  detailsGroupedByObjectives = false,
  isInitiative = false,
  levels,
  staticPlannedColor,
}) {
  const params = useParams();
  const history = useHistory();
  const [isAr, locale] = useIsAr();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [tableData, setTableData] = useState(data || []);

  const getUnitOfMeasure = (item) =>
    item?.UnitOfMeasure === "Percentage" ? "%" : "";

  const sortingByKey = (
    list = [],
    locale,
    enKeyName,
    arKeyName,
    isAscending = true,
    isNumber = false,
    secondKey = null
  ) => {
    const key = locale === "ar" ? arKeyName : enKeyName;
    const sortedArray = isNumber
      ? list?.sort((a, b) =>
          secondKey
            ? a[key]?.[secondKey] - b[key]?.[secondKey]
            : a[key] - b[key]
        )
      : list?.sort((a, b) =>
          secondKey
            ? a[key]?.[secondKey]?.localeCompare(b[key]?.[secondKey], [locale])
            : a[key]?.localeCompare(b[key], [locale])
        );

    // if (isAscending) setTableData([...sortedArray]);
    // else setTableData([...sortedArray].reverse());

    return isAscending ? [...sortedArray] : [...sortedArray].reverse();
  };

  const sortingByFrequency = (list = [], isAscending = true) => {
    const newList = list.map((e) => {
      return { ...e, FrequencyOrder: measuresMonths?.[e.Frequency] };
    });

    const sortedArray = newList?.sort(
      (a, b) => a?.FrequencyOrder - b?.FrequencyOrder
    );

    // if (isAscending) setTableData([...sortedArray]);
    // else setTableData([...sortedArray].reverse());

    return isAscending ? [...sortedArray] : [...sortedArray].reverse();
  };

  const [Frequencies, ProjectBaselineStatuses] = useSelector(({ theme }) => [
    theme.Frequencies.item.Items,
    theme.ProjectBaselineStatuses.item.Items,
  ]);

  const columns = [
    {
      key: "name",
      header: (
        <Space align="center">
          <FormattedMessage id="common.kpi-name" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "EnglishName",
                        "ArabicName"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "EnglishName",
                    "ArabicName"
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "EnglishName",
                        "ArabicName",
                        false
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "EnglishName",
                    "ArabicName",
                    false
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => (isAr ? item?.ArabicName : item?.EnglishName),
      width: "30%",
    },
    {
      key: "frequency",
      header: (
        <Space align="center">
          <FormattedMessage id="common.kpi-frequency" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return { ...e, List: sortingByFrequency(e.List) };
                  });
                } else newData = sortingByFrequency(tableData);

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return { ...e, List: sortingByFrequency(e.List, false) };
                  });
                } else newData = sortingByFrequency(tableData, false);

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => {
        if (item.Frequency === "custom") return item.CustomFrequency || "---";
        else {
          const type = Frequencies.find((e) => e.Value === item.Frequency);

          return isAr ? type?.Arabic : type?.English;
        }
      },
      width: "10%",
    },
    {
      key: "last-update",
      header: (
        <Space align="center">
          <FormattedMessage id="common.last-update" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "UpdateDate",
                        "UpdateDate"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "UpdateDate",
                    "UpdateDate"
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "UpdateDate",
                        "UpdateDate",
                        false
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "UpdateDate",
                    "UpdateDate",
                    false
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) =>
        item.UpdateDate ? moment(item.UpdateDate).format("DD-MM-YYYY") : "---",
      width: "10%",
    },
    {
      key: "target",
      header: (
        <Space align="center">
          <FormattedMessage id="common.target" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "Target",
                        "Target",
                        true,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "Target",
                    "Target",
                    true,
                    true
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "Target",
                        "Target",
                        false,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "Target",
                    "Target",
                    false,
                    true
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) =>
        item?.Target ? `${item?.Target} ${getUnitOfMeasure(item)}` : "---",
      width: "10%",
    },
    {
      key: "value",
      header: (
        <Space align="center">
          <FormattedMessage id="common.value" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "Value",
                        "Value",
                        true,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "Value",
                    "Value",
                    true,
                    true
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "Value",
                        "Value",
                        false,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "Value",
                    "Value",
                    false,
                    true
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) =>
        item?.Value ? `${item?.Value} ${getUnitOfMeasure(item)}` : "---",
      width: "10%",
    },
    {
      key: "status",
      header: <FormattedMessage id="common.status" />,
      cell: (item) => {
        const status = statuses.find((e) => e.Code === item.Status);

        return isAr ? status?.ArabicName : status?.EnglishName;
      },
      width: "10%",
    },

    {
      key: "progress",
      header: (
        <Space align="center">
          <FormattedMessage id="common.out-of-target" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "OutOfTarget",
                        "OutOfTarget",
                        true,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "OutOfTarget",
                    "OutOfTarget",
                    true,
                    true
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        tableData,
                        locale,
                        "OutOfTarget",
                        "OutOfTarget",
                        false,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "OutOfTarget",
                    "OutOfTarget",
                    false,
                    true
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => {
        const status = statuses.find((e) => e.Code === item.Status);
        const hasNoTargetBaseline =
          status?.Value === "NBL" || status?.Value === "MWT";

        const unitOfMeasure = item?.UnitOfMeasure === "Percentage" ? "%" : "";

        return (
          <Space className="progress" gap="5px">
            <ProgressBar
              value={(hasNoTargetBaseline ? 100 : item?.OutOfTarget) || 0}
              color={status?.Color}
            />
            <span style={{ color: status?.Color }}>
              {item?.OutOfTarget || 0}
              {unitOfMeasure}
            </span>
          </Space>
        );
      },
      width: "20%",
    },
  ];
  const initiativecolumns = [
    {
      key: "name",
      header: (
        <Space align="center">
          <FormattedMessage id="initiative.name" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "EnglishName",
                        "ArabicName"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "EnglishName",
                    "ArabicName"
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "EnglishName",
                        "ArabicName",
                        false
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "EnglishName",
                    "ArabicName",
                    false
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => (isAr ? item?.ArabicName : item?.EnglishName),
      width: "30%",
    },
    {
      key: "ManagerModel",
      header: (
        <Space align="center">
          <FormattedMessage id="project.initiative-manager" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "ManagerModel",
                        "ManagerModel",
                        false,
                        false,
                        "DisplayName"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "ManagerModel",
                    "ManagerModel",
                    false,
                    false,
                    "DisplayName"
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "ManagerModel",
                        "ManagerModel",
                        false,
                        false,
                        "DisplayName"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "ManagerModel",
                    "ManagerModel",
                    false,
                    false,
                    "DisplayName"
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => item?.ManagerModel?.DisplayName,
      width: "15%",
    },
    {
      key: "Progress",
      header: (
        <Space align="center">
          <FormattedMessage id="common.actual-progress" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "Progress",
                        "Progress",
                        true,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "Progress",
                    "Progress",
                    true,
                    true
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        tableData,
                        locale,
                        "Progress",
                        "Progress",
                        false,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "Progress",
                    "Progress",
                    false,
                    true
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => {
        const status = statuses.find((e) => e.Code === item.Status);
        return (
          <Space className="progress" gap="5px">
            <ProgressBar value={item?.Progress || 0} color={status?.Color} />
            <span style={{ color: status?.Color }}>{item?.Progress || 0}%</span>
          </Space>
        );
      },
      width: "20%",
    },
    {
      key: "PlannedProgress",
      header: (
        <Space align="center">
          <FormattedMessage id="common.planned-progress" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "PlannedProgress",
                        "PlannedProgress",
                        true,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "PlannedProgress",
                    "PlannedProgress",
                    true,
                    true
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        tableData,
                        locale,
                        "PlannedProgress",
                        "PlannedProgress",
                        false,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "PlannedProgress",
                    "PlannedProgress",
                    false,
                    true
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => {
        const status = statuses.find((e) => e.Code === item.Status);
        return (
          <Space className="progress" gap="5px">
            <ProgressBar
              value={item?.PlannedProgress || 0}
              color={staticPlannedColor ? staticPlannedColor : status?.Color}
            />
            <span
              style={{
                color: staticPlannedColor ? staticPlannedColor : status?.Color,
              }}
            >
              {item?.PlannedProgress || 0}%
            </span>
          </Space>
        );
      },
      width: "20%",
    },
    {
      key: "status",
      header: <FormattedMessage id="common.status" />,
      cell: (item) => {
        const status = statuses.find((e) => e.Code === item.Status);

        return isAr ? status?.ArabicName : status?.EnglishName;
      },
      width: "15%",
      textAlign: "center",
    },
  ];

  const projectsColumns = [
    {
      key: "name",
      header: (
        <Space align="center">
          <FormattedMessage id="common.project-name" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "EnglishName",
                        "ArabicName"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "EnglishName",
                    "ArabicName"
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "EnglishName",
                        "ArabicName",
                        false
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "EnglishName",
                    "ArabicName",
                    false
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => (isAr ? item?.ArabicName : item?.EnglishName),
      width: "20%",
    },
    {
      key: "manager",
      header: (
        <Space align="center">
          <FormattedMessage id="common.project-manager" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "ManagerModel",
                        "ManagerModel",
                        true,
                        false,
                        "DisplayName"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "ManagerModel",
                    "ManagerModel",
                    true,
                    false,
                    "DisplayName"
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "ManagerModel",
                        "ManagerModel",
                        false,
                        false,
                        "DisplayName"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "ManagerModel",
                    "ManagerModel",
                    false,
                    false,
                    "DisplayName"
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => item?.ManagerModel.DisplayName,
      width: "10%",
    },
    {
      key: "status",
      header: <FormattedMessage id="common.project-current-status" />,
      cell: (item) => {
        const status = statuses.find((e) => e.Code === item.Status);

        return isAr ? status?.ArabicName : status?.EnglishName;
      },
      width: "10%",
    },
    {
      key: "planned-progress",
      header: (
        <Space align="center">
          <FormattedMessage id="common.planned-progress" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "PlannedProgress",
                        "PlannedProgress",
                        true,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "PlannedProgress",
                    "PlannedProgress",
                    true,
                    true
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "PlannedProgress",
                        "PlannedProgress",
                        false,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "PlannedProgress",
                    "PlannedProgress",
                    false,
                    true
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => {
        const status = ProjectBaselineStatuses.find(
          (e) => e.Value === item.PlannedStatus
        );

        return (
          <Space className="progress" gap="5px">
            <ProgressBar
              value={item?.PlannedProgress || 0}
              color={staticPlannedColor ? staticPlannedColor : status?.Color}
            />
            <span
              style={{
                color: staticPlannedColor ? staticPlannedColor : status?.Color,
              }}
            >
              {item?.PlannedProgress || 0}%
            </span>
          </Space>
        );
      },
      width: "15%",
    },
    {
      key: "progress",
      header: (
        <Space align="center">
          <FormattedMessage id="common.actual-progress" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "Progress",
                        "Progress",
                        true,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "Progress",
                    "Progress",
                    true,
                    true
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "Progress",
                        "Progress",
                        false,
                        true
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "Progress",
                    "Progress",
                    false,
                    true
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) => {
        const status = statuses.find((e) => e.Code === item.Status);

        return (
          <Space className="progress" gap="5px">
            <ProgressBar value={item?.Progress || 0} color={status?.Color} />
            <span style={{ color: status?.Color }}>{item?.Progress || 0}%</span>
          </Space>
        );
      },
      width: "15%",
    },
    {
      key: "start-date",
      header: (
        <Space align="center">
          <FormattedMessage id="common.project-start-date" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "StartDate",
                        "StartDate"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "StartDate",
                    "StartDate"
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "StartDate",
                        "StartDate",
                        false
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "StartDate",
                    "StartDate",
                    false
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) =>
        item.StartDate ? moment(item.StartDate).format("DD-MM-YYYY") : "---",
      width: "10%",
    },
    {
      key: "finish-date",
      header: (
        <Space align="center">
          <FormattedMessage id="common.project-finish-date" />
          <Space direction="vertical" gap={0}>
            <SortUpIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "FinishDate",
                        "FinishDate"
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "FinishDate",
                    "FinishDate"
                  );

                setTableData(newData);
              }}
            />

            <SortDownIcon
              onClick={() => {
                let newData = [];

                if (detailsGroupedByObjectives) {
                  newData = tableData?.map((e) => {
                    return {
                      ...e,
                      List: sortingByKey(
                        e.List,
                        locale,
                        "FinishDate",
                        "FinishDate",
                        false
                      ),
                    };
                  });
                } else
                  newData = sortingByKey(
                    tableData,
                    locale,
                    "FinishDate",
                    "FinishDate",
                    false
                  );

                setTableData(newData);
              }}
            />
          </Space>
        </Space>
      ),
      cell: (item) =>
        item.FinishDate ? moment(item.FinishDate).format("DD-MM-YYYY") : "---",
      width: "10%",
    },
    // {
    //   key: "update-date",
    //   header: (
    //     <Space align="center">
    //       <FormattedMessage id="common.update-date" />
    //       <Space direction="vertical" gap={0}>
    //         <SortUpIcon
    //           onClick={() => {
    //             let newData = [];

    //             if (detailsGroupedByObjectives) {
    //               newData = tableData?.map((e) => {
    //                 return {
    //                   ...e,
    //                   List: sortingByKey(
    //                     e.List,
    //                     locale,
    //                     "UpdateDate",
    //                     "UpdateDate"
    //                   )
    //                 };
    //               });
    //             } else
    //               newData = sortingByKey(
    //                 tableData,
    //                 locale,
    //                 "UpdateDate",
    //                 "UpdateDate"
    //               );

    //             setTableData(newData);
    //           }}
    //         />

    //         <SortDownIcon
    //           onClick={() => {
    //             let newData = [];

    //             if (detailsGroupedByObjectives) {
    //               newData = tableData?.map((e) => {
    //                 return {
    //                   ...e,
    //                   List: sortingByKey(
    //                     e.List,
    //                     locale,
    //                     "UpdateDate",
    //                     "UpdateDate",
    //                     false
    //                   )
    //                 };
    //               });
    //             } else
    //               newData = sortingByKey(
    //                 tableData,
    //                 locale,
    //                 "UpdateDate",
    //                 "UpdateDate",
    //                 false
    //               );

    //             setTableData(newData);
    //           }}
    //         />
    //       </Space>
    //     </Space>
    //   ),
    //   cell: (item) =>
    //     item.UpdateDate ? moment(item.UpdateDate).format("DD-MM-YYYY") : "---",
    //   width: "10%"
    // }
  ];
  return (
    <Modal isOpen={isOpen} shouldCloseOnOverlayClick onRequestClose={onClose}>
      <div className="details-modal" id="detailsModal">
        <Row justify="between" align="center" className="details-modal__header">
          <Space align="center">
            <TitleIcon className="details-modal__icon" />
            <FormattedMessage id={title} />
          </Space>

          <Space align="center" size="medium">
            <div className="details-modal__filter-wrapper">
              <FormattedMessage id="common.status" />
              <Select
                options={statuses}
                placeholder={<FormattedMessage id="common.select" />}
                getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
                getOptionValue={(el) => el?.Code}
                onChange={(item) => {
                  setSelectedStatus(item);
                }}
                value={selectedStatus}
                isClearable
                maxMenuHeight={125}
              />
            </div>

            <Button
              fill="none"
              variant="dark"
              shape="square"
              onClick={onClose}
              Icon={CloseIcon}
            />
          </Space>
        </Row>

        <Space align="center" className="statuses-wrapper">
          <div>
            <FormattedMessage
              id={
                title === "strategy-map.initiatives-list"
                  ? "common.initiative-status"
                  : isProject
                  ? "common.project-status"
                  : "common.kpi-status"
              }
            />
            :
          </div>

          <Space>
            {statuses.map((_item, index) => (
              <KPIStatusIndicator item={_item} key={index} />
            ))}
          </Space>
        </Space>

        <div className="details-modal__content">
          <Table
            data={
              (selectedStatus
                ? detailsGroupedByObjectives
                  ? tableData?.map((e) => {
                      return {
                        ...e,
                        List: e.List?.filter(
                          (e) => e.Status === selectedStatus?.Code
                        ),
                      };
                    })
                  : tableData?.filter((e) => e.Status === selectedStatus?.Code)
                : tableData) || []
            }
            columns={
              isProject
                ? projectsColumns
                : isInitiative
                ? initiativecolumns
                : columns
            }
            onClickItem={(item) => {
              if (isInitiative && item?.ID) {
                const id = levels?.find((level) =>
                  level?.Levels?.find((_item) => _item?.ID === item?.ID)
                )?.id;
                return history.push(
                  `/splus/objective-details/${id || params?.id}/initiatives/${
                    item?.ID
                  }`
                );
              }
              if (!isProject && item.ID && item?.CanAccess)
                history.push(`/splus/kpi-details/${item?.ID}`);
            }}
            compact
            headerHasBackgroundColor
            isGroupedByObjectives={detailsGroupedByObjectives}
            headerStyle={isInitiative ? { textAlign: "center" } : null}
          />
        </div>
      </div>
    </Modal>
  );
}

export default DetailsModal;
